import { NgModule } from "@angular/core";
import { Ng2ImgMaxService } from "../_services/ng2-img-max.service";
import { ImgMaxSizeService } from "../_services/img-max-size.service";
import { ImgMaxPXSizeService } from "../_services/img-maxpx-size.service";
import { ImgExifService } from "../_services/img-exif.service";
import { Ng2PicaService } from '../_services/ng2-pica.service';
import { ImgCropService, ImgResizeExactService } from "../_services/image-resize.service";

@NgModule({
  providers: [
    Ng2PicaService,
    ImgMaxPXSizeService,
    ImgMaxSizeService,
    ImgExifService,
    Ng2ImgMaxService,
    Ng2PicaService,
    ImgResizeExactService,
    ImgCropService
  ]
})
export class Ng2ImgMaxModule {
}
